
import React from 'react'
import PropTypes from 'prop-types'
import { InfoContext } from './context';

export default function InfoProvider({ children }) {
    const [data, setData] = React.useState({
        userData: [],
        categoryData: [],
        bannerData: [],
        invoiceData: [],
        subscriptionData: [],
        serviceProviderData: [],
        notificationData: [],
        couponData: []
    });

    return (
        <InfoContext.Provider value={{ data, setData }}>
            {children}
        </InfoContext.Provider>
    )

}
InfoProvider.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
}
